import React from 'react'
import { Container, Row } from 'reactstrap'
import { displayDate } from '../../helpers/Common'
import moment from 'moment'

const Footer = (props) => {
  return (
    <>
      <footer className='footer'>
        <Container fluid>
          <Row>
            {/* <Col md='6' className='footer-copyright text-left'>
              <p className='mb-0'>© 2021 - {displayDate(moment(), 'YYYY')} Developed by Kerjoo.com</p>
            </Col> */}
            <div className='col-12 d-flex flex-column-reverse flex-md-row align-items-center align-items-md-center justify-content-center justify-content-md-between' style={{ gap: '.5rem' }}>
              <p className='mb-0'>© 2021 - {displayDate(moment(), 'YYYY')} Developed by Kerjoo.com</p>
              <div className='d-flex justify-content-center justify-content-md-end' style={{ gap: 12 }}>
                <a href='https://play.google.com/store/apps/details?id=com.kerjoo' target='_blank' rel='noopener noreferrer'>
                  <img src='https://raw.githubusercontent.com/almazary/public/master/kerjoo/available-on-google-play.png' alt='available-on-google-play' width={100} />
                </a>
                <a href='https://kerjoo.com/kerjoo-ios/' target='_blank' rel='noopener noreferrer'>
                  <img src='https://raw.githubusercontent.com/almazary/public/master/kerjoo/available-on-app-store.png' alt='available-on-app-store' width={100} />
                </a>
              </div>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  )
}

export default Footer
